import React, { useEffect, useState } from "react";
import { socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import { APP_CONST } from "../../../../config/const";
import { Spinner } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import { addMetaTags, openGraphTags } from "../../../../utils/addMetaTags";
import LeftBarSports from "../../../components/LeftBarSports";

export const COMPONENT_LOAD_TYPE = {
  page: "page",
  component: "component",
};

const AtlasLobby = ({
  loadType = COMPONENT_LOAD_TYPE.page,
  isAuth = false,
}) => {
  const [iframeUrl, setIframeUrl] = useState("");
  var width = window.screen.width;

  const isMobile = width < 800;
  const socket = socketFunc(localStorage.getItem("token"));
  document.body.style.setProperty("--header-background", `#050505`);

  useEffect(() => {
    if (isAuth) {
      getLobbyUrl();
    } else {
      setIframeUrl("https://c225x.play-platform.xyz?token=null");
    }
    updateMetaTags();
  }, [isAuth]);

  const getLobbyUrl = async () => {
    socket.emit(
      "get:atlas_lobby",
      {
        mobile: isMobile,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res.message);
        }
        if (res?.status === "success" && typeof res?.data === "string") {
          setIframeUrl(res?.data);
        }
      }
    );
  };

  const updateMetaTags = () => {
    addMetaTags({
      title: "Funn777 - SportsBook",
      description:
        "Funn777 is a crypto-accepting platform offering a premier experience in online sports betting, casino gaming, and E-sports. Join Funn777 to enjoy live sports events, innovative casino games with fast withdrawals, secure transactions, and safe gambling practices. Sign up today on Funn777.com – your trusted crypto gambling platform for modern sports betting and live casino gaming.",
      keywords:
        "Initial coin offering through betting, Funn777, Crypto Betting, Crypto Casino, Virtual Asset Casino, Online Sports Betting, Casino Gaming, Live Betting, Secure Online Gambling, crypto gambling, Poker, Slots Games, Cricket, Tennis, Andar Bahar, Fast Payouts, Sports Events, Online Casino, Funn777 popular games, Betting Platform, Safe Gambling, Trusted Betting Site, Funn777.com, Popular Betting site",
      metaUrl: "https://Funn777.com/atlas-lobby",
    });
    openGraphTags({
      ogTitle: "Funn777 - SportsBook",
      ogDescription:
        " Funn777 is a crypto-accepting platform offering a premier experience in online sports betting, casino gaming, and E-sports. Join Funn777 to enjoy live sports events, innovative casino games with fast withdrawals, secure transactions, and safe gambling practices. Sign up today on Funn777.com – your trusted crypto gambling platform for modern sports betting and live casino gaming.",
      // ogImage: "../../../../assets/images/seo/og_tags_1024_512.png",
      ogUrl: "https://Funn777.com/atlas-lobby",
      ogType: "website",
      ogKeywords:
        "Initial coin offering through betting, Funn777, Crypto Betting, Crypto Casino, Virtual Asset Casino, Online Sports Betting, Casino Gaming, Live Betting, Secure Online Gambling, crypto gambling, Poker, Slots Games, Cricket, Tennis, Andar Bahar, Fast Payouts, Sports Events, Online Casino, Funn777 popular games, Betting Platform, Safe Gambling, Trusted Betting Site, Funn777.com, Popular Betting site",
    });
  };
  return (
    <>
      {loadType === COMPONENT_LOAD_TYPE.page ? (
        isAuth ? (
          <HeaderAfterLogin />
        ) : (
          <Header />
        )
      ) : null}

      <main className="main live_casino_page live">
        <div className="main-page">
          <LeftBarSports />

          <div className="main-content">
            {!Boolean(iframeUrl) ? (
              <div className="custom_placeholder_parent">
                <div className="custom_placeholder_child">
                  <Spinner animation="grow" variant="primary" size="sm" />
                  <Spinner animation="grow" variant="primary" size="sm" />
                  <Spinner animation="grow" variant="primary" size="sm" />
                </div>
              </div>
            ) : iframeUrl === "notAllowed" ? (
              <Navigate to="/home" />
            ) : iframeUrl === "notFound" ? (
              <Navigate to="/home" />
            ) : (
              <div className="exchange_iframe">
                <iframe
                  title="Exchange"
                  src={iframeUrl}
                  frameBorder="0"
                  // scrolling="no"
                  allowFullScreen={true}
                >
                  Your browser doesn't support iFrames.
                </iframe>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};
export default AtlasLobby;
